/** High-tech skeleton placeholders for mobile lists/cards */
export function Skeleton({
  rows = 3,
  variant = 'card',
}: {
  rows?: number;
  variant?: 'card' | 'kpi' | 'line' | 'chart';
}) {
  if (variant === 'chart') {
    return (
      <div className="tc-mob-skel tc-mob-skel--chart" aria-hidden>
        <div className="tc-mob-skel__bar" style={{ height: '40%' }} />
        <div className="tc-mob-skel__bar" style={{ height: '65%' }} />
        <div className="tc-mob-skel__bar" style={{ height: '50%' }} />
        <div className="tc-mob-skel__bar" style={{ height: '80%' }} />
        <div className="tc-mob-skel__bar" style={{ height: '55%' }} />
        <div className="tc-mob-skel__bar" style={{ height: '90%' }} />
        <div className="tc-mob-skel__bar" style={{ height: '70%' }} />
      </div>
    );
  }

  if (variant === 'kpi') {
    return (
      <div className="tc-mob-kpi-grid tc-mob-kpi-grid--hero" aria-hidden>
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="tc-mob-skel tc-mob-skel--kpi" />
        ))}
      </div>
    );
  }

  if (variant === 'line') {
    return (
      <div className="tc-mob-skel-stack" aria-hidden>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="tc-mob-skel tc-mob-skel--line" />
        ))}
      </div>
    );
  }

  return (
    <div className="tc-mob-card-list" aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="tc-mob-skel tc-mob-skel--card">
          <div className="tc-mob-skel__row">
            <div className="tc-mob-skel__pill" />
            <div className="tc-mob-skel__line tc-mob-skel__line--w40" />
            <div className="tc-mob-skel__line tc-mob-skel__line--w20" />
          </div>
          <div className="tc-mob-skel__row">
            <div className="tc-mob-skel__line tc-mob-skel__line--w30" />
            <div className="tc-mob-skel__line tc-mob-skel__line--w30" />
          </div>
          <div className="tc-mob-skel__chips">
            <div className="tc-mob-skel__chip" />
            <div className="tc-mob-skel__chip" />
            <div className="tc-mob-skel__chip" />
            <div className="tc-mob-skel__chip" />
          </div>
        </div>
      ))}
    </div>
  );
}
